import { handleButtonModifications, sortTags } from './helpers';
function getMappedName(value) {
    switch (value) {
        case 'Alle':
            return 'Alle';
        case 'Trikken':
            return 'Trikken';
        case 'T-Banen':
            return 'T-banen';
        case 'Konsern':
            return 'Konsern';
        case 'Ongoing':
            return 'Aktive prosjekter';
        case 'Finished':
        case 'Fullført':
        case 'Ferdig':
        case 'Avsluttet':
        case 'Avsluttede':
            return 'Avsluttede prosjekter';
        default:
            return value;
    }
}
function isFinisedProjectTag(tag) {
    const tagToLower = tag.toLocaleLowerCase();
    return (tagToLower === 'finished' ||
        tagToLower === 'fullført' ||
        tagToLower === 'ferdig' ||
        tagToLower === 'avsluttet' ||
        tagToLower === 'avsluttede' ||
        tagToLower === 'avsluttede prosjekter');
}
function tagfilter(tagContainer) {
    const listContainerId = tagContainer.dataset.tagFilterListContainer;
    if (!listContainerId) {
        console.debug('No list container id found');
        return;
    }
    const listContainer = document.getElementById(listContainerId);
    if (!listContainer) {
        console.debug('No list container found');
        return;
    }
    const allListItems = listContainer.querySelectorAll('li.spv-listCard');
    const tagfilterables = listContainer.querySelectorAll('[data-tag-filterable]');
    if (tagfilterables.length === 0) {
        console.debug('Found no tag-filterables');
        return;
    }
    console.debug('Found tag-filterables: ', tagfilterables.length);
    const filterMap = new Map();
    tagfilterables.forEach(tagfilterable => {
        const tags = tagfilterable.dataset.tagFilterable?.split(',') || [];
        tags
            .filter(t => t?.length > 0)
            .forEach(tag => {
            const tagList = filterMap.get(tag) || [];
            tagList.push(tagfilterable);
            filterMap.set(tag, tagList);
        });
    });
    const tags = sortTags(Array.from(filterMap.keys()));
    if (tags.length === 0) {
        console.debug('Found no tags');
        return;
    }
    const tagButtons = tags.map(tag => {
        const tagButton = document.createElement('button');
        tagButton.classList.add('spv-tagFilter__button', 'spv-button', 'spv-button--secondary');
        const tagName = getMappedName(tag);
        const isFinishedProjectButtonTag = isFinisedProjectTag(tag);
        tagButton.innerHTML = tagName;
        tagButton.setAttribute('aria-pressed', 'false');
        tagButton.setAttribute('aria-label', 'Filter: Vis ' + tagName);
        tagButton.addEventListener('click', () => {
            if (isFinishedProjectButtonTag) {
                allListItems.forEach(item => {
                    item.classList.add('spv-tagFilter__hidden');
                });
            }
            else {
                allListItems.forEach(item => {
                    item.classList.remove('spv-tagFilter__hidden');
                });
            }
            tagfilterables.forEach(tagfilterable => {
                tagfilterable.classList.add('spv-tagFilter__hidden');
            });
            const tagList = filterMap.get(tag) || [];
            tagList.forEach(tagfilterable => {
                tagfilterable.classList.remove('spv-tagFilter__hidden');
            });
            tagButtons.forEach(button => {
                handleButtonModifications(button, tagButton);
            });
        });
        return tagButton;
    });
    const allButtonText = tagContainer.dataset.tagFilterAllText || 'Alle';
    const allButton = document.createElement('button');
    allButton.classList.add('spv-tagFilter__button', 'spv-button', 'spv-button--primary');
    allButton.innerHTML = allButtonText;
    allButton.setAttribute('aria-pressed', 'true');
    allButton.setAttribute('aria-label', 'Filter: ' + allButtonText);
    allButton.addEventListener('click', () => {
        allListItems.forEach(item => {
            item.classList.remove('spv-tagFilter__hidden');
        });
        tagButtons.forEach(button => {
            handleButtonModifications(button, allButton);
        });
    });
    tagButtons.unshift(allButton);
    tagContainer.append(...tagButtons);
}
export default function initTagfilters() {
    const tagContainers = document.querySelectorAll('[data-tag-filter-list-container]');
    tagContainers.forEach(tagContainer => {
        tagfilter(tagContainer);
    });
}
window.addEventListener('DOMContentLoaded', () => {
    initTagfilters();
});
//# sourceMappingURL=tagfilter.js.map